import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { SuccessDialogComponent } from './success-dialog/success-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { WarningDialogComponent } from './warning-dialog/warning-dialog.component';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { WarningConfirmationDialogComponent } from './warning-confirmation-dialog/warning-confirmation-dialog.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    declarations: [
        ErrorDialogComponent,
        SuccessDialogComponent,
        ConfirmationDialogComponent,
        DeleteDialogComponent,
        WarningDialogComponent,
        InfoDialogComponent,
        WarningConfirmationDialogComponent,
    ],
    imports: [CommonModule, TranslocoModule],
})
export class InfoDialogsModule {}
